﻿class MainMenu {
  constructor(el) {
    this.dom = {};
    this.dom.el = el;
    this.setupDom()
    this.bindEvents()
  }

  toggleMenuItem = e => {
    if (e.type !== 'click' && e.which !== 13) return
    const menu = e.currentTarget.parentElement
    this.dom.links.forEach(link => link !== e.currentTarget && link.parentElement.classList.remove('open'))
    menu.classList.toggle('open')
    let expanded = menu.classList.contains('open')
    e.currentTarget.setAttribute('aria-expanded', expanded)
    e.stopPropagation()
    return false
  }

  toggleMenu = e => {
    if (e.type !== 'click' && e.which !== 13) return
    this.dom.menuToggle.classList.toggle('open')
    this.dom.el.classList.toggle('open')
    let expanded = this.dom.menuToggle.classList.contains('open')
    this.dom.menuToggle.setAttribute('aria-expanded', expanded)
    e.stopPropagation()
    return false
  }

  closeAll = e => {
    if (!e.target.media && this.dom.el.contains(e.target)) return
    this.dom.links.forEach(link => link.parentElement.classList.remove('open'))
    this.dom.el.classList.remove('open')
    this.dom.menuToggle.classList.remove('open')
  }

  setupDom = () => {
    this.dom.links = this.dom.el.querySelectorAll('.has-menu > a')
    this.dom.menuToggle = document.getElementById('hamburger-link')
    this.dom.min1200 = window.matchMedia('(min-width: 1200px)')
  }

  bindEvents = () => {
    this.dom.links.forEach(link => {
      link.addEventListener('click', this.toggleMenuItem)
      link.addEventListener('keypress', this.toggleMenuItem)
    })
    document.addEventListener('click', this.closeAll)
    this.dom.menuToggle.addEventListener('click', this.toggleMenu)
    this.dom.menuToggle.addEventListener('keypress', this.toggleMenu)
    this.dom.min1200.addEventListener('change', this.closeAll)
  }

  static init = () => {
    const menu = document.querySelector('.main-menu')
    new MainMenu(menu)
  }
}

export default MainMenu
